var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKitliIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    x: 0,
    y: 0,
    enableBackground: "new 0 0 128 128",
    viewBox: "0 0 128 128",
    xmlSpace: "preserve",
    width: 256,
    height: 256,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M97.2 127.5H20.6c-1.1 0-2-.9-2-2v-9.2c0-1.1.9-2 2-2h76.6c1.1 0 2 .9 2 2v9.2C99.2 126.6 98.3 127.5 97.2 127.5zM22.6 123.5h72.6v-5.2H22.6V123.5zM79.8 35c-.3 0-.6-.1-.9-.2L42 15.4c-.5-.2-.8-.7-1-1.2-.2-.5-.1-1.1.1-1.5C47 1.6 60.8-2.7 71.9 3.1l0 0c5.4 2.8 9.4 7.6 11.2 13.4 1.8 5.8 1.2 12-1.6 17.4-.2.5-.7.8-1.2 1C80.2 35 80 35 79.8 35zM45.7 12.9l33.2 17.4c1.6-4 1.8-8.4.5-12.5-1.5-4.8-4.8-8.7-9.2-11.1l0 0C61.5 2.1 51 5 45.7 12.9zM22 65.2c-.9 0-1.8-.7-2-1.6l-6.2-30.8c-.1-.6.1-1.3.5-1.8.4-.5 1.1-.7 1.7-.6l20.3 2.8c1.1.2 1.9 1.2 1.7 2.3s-1.2 1.9-2.3 1.7l-17.5-2.4L24 62.8c.2 1.1-.5 2.1-1.6 2.4C22.3 65.2 22.2 65.2 22 65.2zM104.3 102.4h-4.7c-1.1 0-2-.9-2-2s.9-2 2-2h4.7c3.3 0 5.9-2.7 5.9-5.9V51c0-3.3-2.7-5.9-5.9-5.9H87.5c-1.1 0-2-.9-2-2s.9-2 2-2h16.8c5.5 0 9.9 4.4 9.9 9.9v41.5C114.2 97.9 109.8 102.4 104.3 102.4z",
    className: "color303c42 svgShape"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M97.3,118.3H20.6c-0.9,0-1.8-0.7-2-1.6c-1.7-7.7-2.5-15.8-2.5-24.1c0-25.2,7.7-48,20.5-61     c0.4-0.4,0.9-0.6,1.4-0.6h41.7c0.5,0,1,0.2,1.4,0.6c12.8,13,20.5,35.8,20.5,61c0,8.3-0.8,16.4-2.5,24.1     C99,117.6,98.2,118.3,97.3,118.3z M22.3,114.3h73.4c1.4-7,2.1-14.3,2.1-21.7c0-23.4-7.2-45.4-18.8-57.6H39     C27.4,47.2,20.2,69.2,20.2,92.6C20.2,100,20.9,107.3,22.3,114.3z",
    className: "color303c42 svgShape"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M90.6,109.3H27.3c-0.6,0-1-0.4-1-1s0.4-1,1-1h62.4c0.7-4.8,1-9.7,1-14.7c0-20.5-5.7-39.6-15.2-50.9     c-0.4-0.4-0.3-1.1,0.1-1.4c0.4-0.4,1.1-0.3,1.4,0.1c9.8,11.7,15.7,31.3,15.7,52.2c0,5.4-0.4,10.7-1.1,15.8     C91.5,108.9,91.1,109.3,90.6,109.3z",
    className: "color303c42 svgShape"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKitliIcon);
export default __webpack_public_path__ + "static/media/kitli-icon.371c1a23d6108e0a5e6d5cfa400b5cba.svg";
export { ForwardRef as ReactComponent };